import { eEnv } from '../../constants';

export const RUNNING_ENVIRONMENT = (
  process.env.VITE_NODE_ENV ? process.env.VITE_NODE_ENV : eEnv.DEV
) as eEnv;

export const IS_DEVELOPMENT =
  RUNNING_ENVIRONMENT === eEnv.DEV ||
  RUNNING_ENVIRONMENT === eEnv.LOCAL ||
  RUNNING_ENVIRONMENT === eEnv.STAGE ||
  RUNNING_ENVIRONMENT === eEnv.TEST;

/**
 * True only for a local `vite serve` (VITE_NODE_ENV forced to 'localhost' by vite.config define).
 * The blob-container proxy rewrite is only valid here, where the Vite dev-server proxy forwards
 * the rewritten request to real blob storage. On deployed dev/test/stage there is no such proxy,
 * so the rewrite must NOT happen — it would point tenant CSS at the app origin and 404.
 */
export const IS_LOCAL = RUNNING_ENVIRONMENT === eEnv.LOCAL;
